import styled from 'styled-components';
import { token } from '@zillow/constellation';

export const Container = styled.div`
  width: 100%;
  max-width: 710px;
  background: ${token('colors.white')};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 36px;
  padding: 24px;
`;

export const HeadingContainer = styled.div`
  text-align: center;
`;

export const AddressInputContainer = styled.div`
  width: 100%;
`;

export const Row = styled.div`
  width: 100%;
  margin: 8px 0 4px;
  display: flex;
  justify-content: space-between;
`;

export const PropertyTypeContainer = styled.div`
  width: 100%;
`;

export const UnitInputContainer = styled.div`
  width: 30%;
  max-width: 210px;
  margin-left: 24px;
`;

export const SharedPropertyContainer = styled.div`
  width: 100%;
  min-height: 30px;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
